export const FORM_MODE = {
  EDIT: 'edit',
  READONLY: 'readOnly',
  AMEND: 'amend'
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/constant/form-mode.constant.ts